import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { TaxesArticle } from './pages/TaxesArticle';
export function App() {
  return <BrowserRouter data-id="element-0">
      <div className="w-full min-h-screen bg-slate-900" data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/taxes" element={<TaxesArticle data-id="element-4" />} data-id="element-3" />
          <Route path="/" element={<Navigate to="/taxes" replace data-id="element-6" />} data-id="element-5" />
        </Routes>
      </div>
    </BrowserRouter>;
}